<template>
	<div class="password-update-container">
		<!-- 页面头部 -->
		<div class="page-header">
			<div class="header-content">
				<div class="header-icon">
					<svg class="icon" viewBox="0 0 24 24">
						<path d="M18,8H17V6A5,5 0 0,0 7,6V8H6A2,2 0 0,0 4,10V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V10A2,2 0 0,0 18,8M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M15.8,8H8.2V6A3.8,3.8 0 0,1 12,2.2A3.8,3.8 0 0,1 15.8,6V8Z"/>
					</svg>
				</div>
				<div class="header-text">
					<h1 class="page-title">修改密码</h1>
					<p class="page-description">为了您的账户安全，请定期更换密码</p>
				</div>
			</div>
		</div>

		<!-- 安全提示卡片 -->
		<div class="security-tips">
			<div class="tips-header">
				<svg class="tip-icon" viewBox="0 0 24 24">
					<path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1Z"/>
				</svg>
				<span class="tips-title">安全提醒</span>
			</div>
			<ul class="tips-list">
				<li class="tip-item">
					<i class="el-icon-check"></i>
					密码长度至少8位，包含字母和数字
				</li>
				<li class="tip-item">
					<i class="el-icon-check"></i>
					建议包含大小写字母、数字和特殊字符
				</li>
				<li class="tip-item">
					<i class="el-icon-check"></i>
					避免使用生日、姓名等容易被猜到的信息
				</li>
			</ul>
		</div>

		<!-- 密码修改表单 -->
		<div class="form-container">
			<el-form
				ref="ruleForm"
				:rules="rules"
				:model="ruleForm"
				label-width="120px"
				class="password-form"
			>
				<div class="form-section">
					<h3 class="section-title">密码验证与修改</h3>
					
					<el-form-item label="原密码" prop="password" class="form-item">
						<div class="input-wrapper">
							<div class="input-field">
								<svg class="field-icon" viewBox="0 0 24 24">
									<path d="M18,8H17V6A5,5 0 0,0 7,6V8H6A2,2 0 0,0 4,10V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V10A2,2 0 0,0 18,8M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M15.8,8H8.2V6A3.8,3.8 0 0,1 12,2.2A3.8,3.8 0 0,1 15.8,6V8Z"/>
								</svg>
								<el-input 
									v-model="ruleForm.password" 
									show-password 
									placeholder="请输入原密码"
									class="password-input"
								></el-input>
							</div>
						</div>
					</el-form-item>

					<el-form-item label="新密码" prop="newpassword" class="form-item">
						<div class="input-wrapper">
							<div class="input-field">
								<svg class="field-icon" viewBox="0 0 24 24">
									<path d="M22,18V22H18V19H15V16H12L9.74,13.74C9.19,13.91 8.61,14 8,14A6,6 0 0,1 2,8A6,6 0 0,1 8,2A6,6 0 0,1 14,8C14,8.61 13.91,9.19 13.74,9.74L22,18M7,5A2,2 0 0,0 5,7A2,2 0 0,0 7,9A2,2 0 0,0 9,7A2,2 0 0,0 7,5Z"/>
								</svg>
								<el-input 
									v-model="ruleForm.newpassword" 
									show-password 
									placeholder="请输入新密码"
									class="password-input"
									@input="checkPasswordStrength"
								></el-input>
							</div>
							<!-- 密码强度指示器 -->
							<div class="password-strength" v-if="ruleForm.newpassword">
								<div class="strength-label">密码强度：</div>
								<div class="strength-bars">
									<div 
										class="strength-bar" 
										:class="{ 'active': passwordStrength >= 1, 'weak': passwordStrength === 1 }"
									></div>
									<div 
										class="strength-bar" 
										:class="{ 'active': passwordStrength >= 2, 'medium': passwordStrength === 2 }"
									></div>
									<div 
										class="strength-bar" 
										:class="{ 'active': passwordStrength >= 3, 'strong': passwordStrength === 3 }"
									></div>
								</div>
								<span class="strength-text" :class="strengthClass">{{ strengthText }}</span>
							</div>
						</div>
					</el-form-item>

					<el-form-item label="确认密码" prop="repassword" class="form-item">
						<div class="input-wrapper">
							<div class="input-field">
								<svg class="field-icon" viewBox="0 0 24 24">
									<path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z"/>
								</svg>
								<el-input 
									v-model="ruleForm.repassword" 
									show-password 
									placeholder="请确认新密码"
									class="password-input"
								></el-input>
								<!-- 密码匹配指示 -->
								<div class="match-indicator" v-if="ruleForm.repassword">
									<svg v-if="passwordsMatch" class="match-icon success" viewBox="0 0 24 24">
										<path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z"/>
									</svg>
									<svg v-else class="match-icon error" viewBox="0 0 24 24">
										<path d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"/>
									</svg>
								</div>
							</div>
							<div v-if="ruleForm.repassword && !passwordsMatch" class="error-tip">
								两次输入的密码不一致
							</div>
						</div>
					</el-form-item>
				</div>

				<!-- 操作按钮 -->
				<div class="form-actions">
					<el-button 
						type="primary" 
						@click="onUpdateHandler"
						:loading="updateLoading"
						:disabled="!canSubmit"
						class="submit-btn"
					>
						<i class="el-icon-check"></i>
						{{ updateLoading ? '更新中...' : '确认修改' }}
					</el-button>
					<el-button @click="resetForm" class="reset-btn">
						<i class="el-icon-refresh-left"></i>
						重置
					</el-button>
				</div>
			</el-form>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			dialogVisible: false,
			updateLoading: false,
			passwordStrength: 0,
			ruleForm: {
				password: '',
				newpassword: '',
				repassword: ''
			},
			user: {},
			rules: {
				password: [
					{
						required: true,
						message: "原密码不能为空",
						trigger: "blur"
					}
				],
				newpassword: [
					{
						required: true,
						message: "新密码不能为空",
						trigger: "blur"
					},
					{
						min: 6,
						message: "新密码长度不能少于6位",
						trigger: "blur"
					}
				],
				repassword: [
					{
						required: true,
						message: "确认密码不能为空",
						trigger: "blur"
					},
					{
						validator: (rule, value, callback) => {
							if (value !== this.ruleForm.newpassword) {
								callback(new Error('两次输入的密码不一致'));
							} else {
								callback();
							}
						},
						trigger: "blur"
					}
				]
			}
		};
	},

	computed: {
		// 密码是否匹配
		passwordsMatch() {
			return this.ruleForm.newpassword && this.ruleForm.repassword && 
				   this.ruleForm.newpassword === this.ruleForm.repassword;
		},

		// 密码强度文本
		strengthText() {
			const texts = ['弱', '中', '强'];
			return texts[this.passwordStrength - 1] || '';
		},

		// 密码强度样式类
		strengthClass() {
			const classes = ['weak-text', 'medium-text', 'strong-text'];
			return classes[this.passwordStrength - 1] || '';
		},

		// 是否可以提交
		canSubmit() {
			return this.ruleForm.password && 
				   this.ruleForm.newpassword && 
				   this.ruleForm.repassword && 
				   this.passwordsMatch && 
				   !this.updateLoading;
		}
	},

	mounted() {
		this.$http({
			url: `${this.$storage.get("sessionTable")}/session`,
			method: "get"
		}).then(({ data }) => {
			if (data && data.code === 0) {
				this.user = data.data;
			} else {
				this.$message.error(data.msg);
			}
		});
	},

	methods: {
		// 检查密码强度
		checkPasswordStrength() {
			const password = this.ruleForm.newpassword;
			if (!password) {
				this.passwordStrength = 0;
				return;
			}

			let strength = 0;
			
			// 长度检查
			if (password.length >= 8) strength++;
			
			// 包含数字和字母
			if (/[0-9]/.test(password) && /[a-zA-Z]/.test(password)) strength++;
			
			// 包含大小写和特殊字符
			if (/[a-z]/.test(password) && /[A-Z]/.test(password) && /[^a-zA-Z0-9]/.test(password)) {
				strength++;
			}

			this.passwordStrength = Math.max(1, Math.min(3, strength));
		},

		// 重置表单
		resetForm() {
			this.ruleForm = {
				password: '',
				newpassword: '',
				repassword: ''
			};
			this.passwordStrength = 0;
			if (this.$refs.ruleForm) {
				this.$refs.ruleForm.clearValidate();
			}
		},

		onLogout() {
			this.$storage.remove("Token");
			this.$router.replace({ name: "login" });
		},

		// 修改密码 (保持原有逻辑)
		onUpdateHandler() {
			this.$refs["ruleForm"].validate(valid => {
				if (valid) {
					this.updateLoading = true;
					
					var password = "";
					if (this.user.mima) {
						password = this.user.mima;
					} else if (this.user.password) {
						password = this.user.password;
					}
					if (this.user.password) {
						password = this.user.password;
					} else if (this.user.password) {
						password = this.user.password;
					}
					if (this.ruleForm.password != password) {
						this.$message.error("原密码错误");
						this.updateLoading = false;
						return;
					}
					if (this.ruleForm.newpassword != this.ruleForm.repassword) {
						this.$message.error("两次密码输入不一致");
						this.updateLoading = false;
						return;
					}
					this.user.password = this.ruleForm.newpassword;
					this.user.mima = this.ruleForm.newpassword;
					this.$http({
						url: `${this.$storage.get("sessionTable")}/update`,
						method: "post",
						data: this.user
					}).then(({ data }) => {
						this.updateLoading = false;
						if (data && data.code === 0) {
							this.$message({
								message: "修改密码成功,下次登录系统生效",
								type: "success",
								duration: 1500,
								onClose: () => {
									this.resetForm();
								}
							});
						} else {
							this.$message.error(data.msg);
						}
					}).catch(() => {
						this.updateLoading = false;
						this.$message.error("网络错误，请稍后重试");
					});
				}
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.password-update-container {
	background: #f8fafc;
	min-height: 100vh;
	padding: 24px;
}

// 页面头部
.page-header {
	margin-bottom: 24px;
	
	.header-content {
		display: flex;
		align-items: center;
		gap: 16px;
		background: white;
		padding: 24px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

		.header-icon {
			width: 56px;
			height: 56px;
			background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
			border-radius: 12px;
			display: flex;
			align-items: center;
			justify-content: center;
			box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);

			.icon {
				width: 24px;
				height: 24px;
				fill: white;
			}
		}

		.header-text {
			flex: 1;

			.page-title {
				font-size: 24px;
				font-weight: 600;
				color: #1e293b;
				margin: 0 0 4px 0;
			}

			.page-description {
				color: #64748b;
				font-size: 14px;
				margin: 0;
			}
		}
	}
}

// 安全提示
.security-tips {
	background: white;
	border-radius: 8px;
	padding: 20px;
	margin-bottom: 24px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	border-left: 4px solid #10b981;

	.tips-header {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-bottom: 16px;

		.tip-icon {
			width: 20px;
			height: 20px;
			fill: #10b981;
		}

		.tips-title {
			font-size: 16px;
			font-weight: 600;
			color: #1e293b;
		}
	}

	.tips-list {
		list-style: none;
		padding: 0;
		margin: 0;

		.tip-item {
			display: flex;
			align-items: center;
			gap: 8px;
			margin-bottom: 8px;
			color: #4b5563;
			font-size: 14px;

			&:last-child {
				margin-bottom: 0;
			}

			i {
				color: #10b981;
				font-size: 12px;
			}
		}
	}
}

// 表单容器
.form-container {
	max-width: 600px;
	margin: 0 auto;
}

// 密码表单
.password-form {
	background: white;
	padding: 32px;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

	.form-section {
		.section-title {
			font-size: 18px;
			font-weight: 600;
			color: #1e293b;
			margin: 0 0 24px 0;
			padding-bottom: 8px;
			border-bottom: 2px solid #e2e8f0;
		}
	}

	// 表单项
	.form-item {
		margin-bottom: 24px;

		:deep(.el-form-item__label) {
			font-weight: 500;
			color: #374151;
			line-height: 32px;
		}
	}

	// 输入包装器
	.input-wrapper {
		width: 100%;
	}

	// 输入字段
	.input-field {
		position: relative;
		display: flex;
		align-items: center;
		border: 1px solid #d1d5db;
		border-radius: 8px;
		transition: all 0.2s ease;
		background: #fafafa;

		&:focus-within {
			border-color: #3b82f6;
			box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
			background: white;
		}

		.field-icon {
			width: 18px;
			height: 18px;
			fill: #9ca3af;
			margin: 0 12px 0 16px;
			flex-shrink: 0;
		}

		.password-input {
			flex: 1;

			:deep(.el-input__inner) {
				border: none;
				background: transparent;
				font-size: 14px;
				padding: 12px 16px 12px 0;
				height: auto;

				&:focus {
					border: none;
					box-shadow: none;
				}

				&::placeholder {
					color: #9ca3af;
				}
			}

			:deep(.el-input__suffix) {
				right: 12px;
			}
		}

		// 密码匹配指示器
		.match-indicator {
			margin-right: 12px;

			.match-icon {
				width: 16px;
				height: 16px;

				&.success {
					fill: #10b981;
				}

				&.error {
					fill: #ef4444;
				}
			}
		}
	}

	// 密码强度指示器
	.password-strength {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-top: 8px;
		font-size: 12px;

		.strength-label {
			color: #6b7280;
		}

		.strength-bars {
			display: flex;
			gap: 2px;

			.strength-bar {
				width: 20px;
				height: 4px;
				background: #e5e7eb;
				border-radius: 2px;
				transition: all 0.2s ease;

				&.active {
					&.weak {
						background: #ef4444;
					}

					&.medium {
						background: #f59e0b;
					}

					&.strong {
						background: #10b981;
					}
				}
			}
		}

		.strength-text {
			font-weight: 500;

			&.weak-text {
				color: #ef4444;
			}

			&.medium-text {
				color: #f59e0b;
			}

			&.strong-text {
				color: #10b981;
			}
		}
	}

	// 错误提示
	.error-tip {
		color: #ef4444;
		font-size: 12px;
		margin-top: 4px;
		display: flex;
		align-items: center;
		gap: 4px;
	}
}

// 操作按钮
.form-actions {
	padding-top: 24px;
	border-top: 1px solid #e5e7eb;
	display: flex;
	gap: 12px;
	justify-content: center;

	.el-button {
		padding: 12px 32px;
		font-weight: 500;
		border-radius: 8px;
		font-size: 14px;

		i {
			margin-right: 4px;
		}
	}

	.submit-btn {
		&:disabled {
			opacity: 0.6;
			cursor: not-allowed;
		}
	}

	.reset-btn {
		color: #6b7280;
		border-color: #d1d5db;

		&:hover {
			color: #374151;
			border-color: #9ca3af;
		}
	}
}

// 响应式设计
@media (max-width: 768px) {
	.password-update-container {
		padding: 16px;
	}

	.page-header {
		.header-content {
			padding: 20px;

			.header-icon {
				width: 48px;
				height: 48px;

				.icon {
					width: 20px;
					height: 20px;
				}
			}

			.header-text {
				.page-title {
					font-size: 20px;
				}

				.page-description {
					font-size: 13px;
				}
			}
		}
	}

	.security-tips {
		padding: 16px;

		.tips-header {
			.tips-title {
				font-size: 15px;
			}
		}

		.tips-list {
			.tip-item {
				font-size: 13px;
			}
		}
	}

	.password-form {
		padding: 24px;

		.form-section {
			.section-title {
				font-size: 16px;
			}
		}

		.form-item {
			margin-bottom: 20px;

			:deep(.el-form-item__label) {
				font-size: 14px;
			}
		}
	}

	.form-actions {
		flex-direction: column;
		gap: 8px;

		.el-button {
			width: 100%;
		}
	}
}

@media (max-width: 480px) {
	.password-update-container {
		padding: 12px;
	}

	.page-header {
		.header-content {
			flex-direction: column;
			text-align: center;
			gap: 12px;
		}
	}

	.form-container {
		max-width: 100%;
	}

	.password-form {
		padding: 20px;

		.input-field {
			.field-icon {
				margin: 0 8px 0 12px;
			}

			.password-input {
				:deep(.el-input__inner) {
					font-size: 16px; // 防止移动端缩放
				}
			}
		}

		.password-strength {
			flex-wrap: wrap;
			gap: 6px;

			.strength-bars {
				order: 2;
				width: 100%;
				justify-content: flex-start;
			}

			.strength-label,
			.strength-text {
				order: 1;
			}
		}
	}
}
</style>
